"use client";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { downloadFile } from "../../utils/downloadFile";
import { CustomSVG } from "../_primitives/CustomSVG/CustomSVG.server";
import { Button, ButtonTypes } from "../Button/Button";
import styles from "./ExtendedLink.module.scss";

type DownloadButtonProps = {
  iconOnly: boolean;
  children: React.ReactNode;
  extraClass?: string;
  btnType: ButtonTypes;
  ariaLabel: string;
  linkTargetUrl: string | false;
};
export const DownloadButton = ({
  iconOnly,
  children,
  extraClass,
  // btnType,
  ariaLabel,
  linkTargetUrl,
}: DownloadButtonProps) => {
  const { getIcon } = useGlobalContext();

  const handleDownload = (fileUrl: string) => {
    downloadFile(fileUrl).catch((e) => {
      console.error("Download failed:", e);
      // Handle error if needed
    });
  };

  const renderDownloadButton = () =>
    linkTargetUrl && (
      <Button
        type={"secondary"}
        href=""
        target=""
        isDownload
        className={`${extraClass} ${styles["download-btn"]}`}
        aria-label={ariaLabel}
        onClick={() => handleDownload(linkTargetUrl)}
      >
        {children}
      </Button>
    );

  const renderDownloadIcon = () =>
    linkTargetUrl && (
      <button
        type="button"
        className={`${styles["download-link-icon"]} ${extraClass}`}
        aria-label={ariaLabel}
        onClick={() => handleDownload(linkTargetUrl)}
      >
        <CustomSVG
          src={getIcon("download")}
          wrapper="span"
          width={38}
          height={38}
          aria-hidden="true"
        />
      </button>
    );
  return iconOnly ? renderDownloadIcon() : renderDownloadButton();
};
